module.exports = __webpack_public_path__ + "assets/img/5a5f-tk.svg";